
import {
  BsDatepickerModule,
  BsDatepickerConfig
} from "ngx-bootstrap/datepicker";

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbAlertModule, NgbDatepickerModule,NgbTimepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

// *******************************************************************************
// Layouts

// import { Layout1Component } from './layout-1/layout-1.component';


// *******************************************************************************
// Components

// import { LayoutSidenavComponent } from './layout-sidenav/layout-sidenav.component';
// import { LayoutFooterComponent } from './layout-footer/layout-footer.component';
// import {LayoutNavbarComponent} from './layout-navbar/layout-navbar.component';

// *******************************************************************************
// Libs

// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { SidenavModule } from '../../vendor/libs/sidenav/sidenav.module';




// *******************************************************************************
// Services

// import { LayoutService } from './layout.service';


// *******************************************************************************
import { TabsComponent } from '../tabs/tabs.component';
import { TabComponent } from '../tabs/tab.component';
import { DynamicComponentComponent } from './dynamic-component/dynamic-component.component';
// import { ReportComponentComponent } from './report-component/report-component.component';
// import { PageComponentComponent } from './page-component/page-component.component';
// import { PreviewComponent } from '../preview-html/previewComponent';
// import { LayoutSidenavRightComponent } from './layout-sidenav-right/layout-sidenav-right.component';
//
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
// import { ConfiguredSearchComponent } from './configured-search/configured-search.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
// import { DragulaModule } from 'ng2-dragula';
// import { NgxPowerBiModule } from 'ngx-powerbi';
// import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
// import { FileComponent } from './file/file.component';
// import { FiledirectiveDirective } from './file/filedirective.directive';
// import { MyUploadsComponent } from './file/my-uploads/my-uploads.component';
// import { AgentscriptPreviewComponent } from '../agentscript-preview/agentscript-preview.component';
// import { ReportViewModuleModule } from '../report-view-module/report-view-module.module';
// import { AdvancedSearchComponent } from '../advanced-search/advanced-search.component';
// import { QueryProcessorComponent } from './query-processor/query-processor.component';
// import { DynamicFormsComponent } from './dynamic-forms/dynamic-forms.component';
// import { ReportLinkComponent } from '../report-link/report-link.component';
import { HomeComponent } from '../home/home.component';
import { LayoutComponent } from './layout/layout.component';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../app-routing.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { AdvancedSearchComponent } from '../advanced-search/advanced-search.component';
import { ReportViewModuleModule } from '../report-view-module/report-view-module.module';
import { PreviewComponent } from '../preview-html/previewComponent';
import { queryProcessor } from '../model/dynamicForm/queryProcessor';
import { ReportLinkComponent } from '../report-link/report-link.component';
import { DynamicFormsComponent } from './dynamic-forms/dynamic-forms.component';
import { QueryProcessorComponent } from './query-processor/query-processor.component';
import { QueryProcessorVirtualRowComponent } from './query-processor/query-processor-virtual-row.component';
// import { SmartReporterModule } from '../SmartReporter/SmartReporter.module';
// import { SmDisplayingReportComponent } from '../SmartReporter/sm-displaying-report/sm-displaying-report.component';
import { Sample1Component } from '../sample1/sample1.component';
import { Sample2Component } from '../sample2/sample2.component';
import { Sample3Component } from '../sample3/sample3.component';
import { Sample4Component } from '../sample4/sample4.component';
import { CreateNewSRComponent } from '../NewServiceRequest/create-new-sr/create-new-sr.component';
import { SelectServiceTypeComponent } from '../NewServiceRequest/select-service-type/select-service-type.component';
import { GridViewSrComponent } from '../NewServiceRequest/grid-view-sr/grid-view-sr.component';
import { AdditionalInfoComponent } from '../NewServiceRequest/additional-info/additional-info.component';
import { AddressDetailsComponent } from '../NewServiceRequest/address-details/address-details.component';
import { GoogleMapComponent } from '../NewServiceRequest/google-map/google-map.component';
import { EsriMapComponent } from '../NewServiceRequest/esri-map/esri-map.component';
import { PopupSubmitComponent } from '../NewServiceRequest/popup-submit/popup-submit.component';
import { ReviewSubmitComponent } from '../NewServiceRequest/review-submit/review-submit.component';
import { AgentScriptComponent } from '../NewServiceRequest/agent-script/agent-script.component';
import { SaveNewSrComponent } from '../NewServiceRequest/save-new-sr/save-new-sr.component';
import { EditpopupComponent } from '../editpopup/editpopup.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { KnowledgebaseComponent } from '../NewServiceRequest/knowledgebase/knowledgebase.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { TrackingViewComponent } from '../tracking-view/tracking-view.component';
import { TracksrComponent } from '../tracksr/tracksr.component';
import { AddressDialogComponent } from '../NewServiceRequest/address-dialog/address-dialog.component';
import { ContactLookupDialogComponent } from '../NewServiceRequest/contact-lookup-dialog/contact-lookup-dialog.component';
import { AlertIncidentComponent } from '../alert-incident/alert-incident.component';
import { FroalaEditorModule } from 'angular-froala-wysiwyg';
import 'froala-editor/js/plugins.pkgd.min.js';
import { TagInputModule } from 'ngx-chips';
import { PhonemaskDirective } from '../phonemask.directive';
import { ScriptValidatorDirective } from '../NewServiceRequest/agent-script/script-validator.directive';
import { SmartreportsComponent } from '../NewServiceRequest/smartreports/smartreports.component';
import { FaqComponent } from './knowledge-center/faq/faq.component';
import { CommunityForumComponent } from './knowledge-center/community-forum/community-forum.component';
import { HelpComponent } from './knowledge-center/help/help.component';
import { TrainingComponent } from './knowledge-center/training/training.component';
import { TableaureportComponent } from '../NewServiceRequest/tableaureport/tableaureport.component';
import { GlobalsearchcomponentComponent } from './globalsearchcomponent/globalsearchcomponent.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ApiserviceService } from "../Service/apiservice.service";
import { NotificationmodalComponent } from "../notificationmodal/notificationmodal.component";
import { KnowledgebasecomponentscriptComponent } from "../knowledgebasecomponentscript/knowledgebasecomponentscript.component";
import { NewgridComponent } from './../newgrid/newgrid.component';
import { NewanswerComponent } from "../newanswer/newanswer.component";
import { RecentticketsComponent } from "../recenttickets/recenttickets.component";
import { AttachmentsViewComponent } from "../attachments/attachments-view/attachments-view.component";
import { MarkdownModule } from 'ngx-markdown';
import { AiknowledgebaseComponent } from "../aiknowledgebase/aiknowledgebase.component";
@NgModule({
  imports: [
    // SmartReporterModule,
    ReportViewModuleModule,
    CommonModule,
    RouterModule,
    // NgbModule,
    // SidenavModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    NgbPopoverModule,
    CdkTableModule,
    MatSlideToggleModule,
    A11yModule,
    CdkAccordionModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,NgbTooltipModule,
    NgbModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    NgbDropdownModule,
    NgxPaginationModule,

    NgMultiSelectDropDownModule.forRoot(),

    NgSelectModule,
    // DragulaModule.forRoot(),
    // NgxPowerBiModule,
    // MultiSelectAllModule,
    // ReportViewModuleModule,
    FroalaEditorModule.forRoot(),
    TagInputModule,

  BsDatepickerModule.forRoot(),
  MarkdownModule.forRoot(),

  ],
  declarations: [
    // Layout1Component,
    // LayoutSidenavComponent,
    // LayoutFooterComponent,
    // LayoutNavbarComponent,
    AttachmentsViewComponent,
    KnowledgebasecomponentscriptComponent,
    NotificationmodalComponent,
    PhonemaskDirective,
    ScriptValidatorDirective,
    SmartreportsComponent,
    TableaureportComponent,
    KnowledgebaseComponent,
    TabsComponent,
    TabComponent,
    DynamicComponentComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    AdvancedSearchComponent,
    PreviewComponent,

    // SmDisplayingReportComponent,
    Sample1Component,
    Sample2Component,
    Sample3Component,
    Sample4Component,
    EditpopupComponent,
    CreateNewSRComponent,
    SelectServiceTypeComponent,
    GridViewSrComponent,
    AdditionalInfoComponent,
    AddressDetailsComponent,
    GoogleMapComponent,
    EsriMapComponent,
    PopupSubmitComponent,
    ReviewSubmitComponent,
    FaqComponent,
    AgentScriptComponent,
    SaveNewSrComponent,
    TrackingViewComponent,
    TracksrComponent,
    AddressDialogComponent,
    ContactLookupDialogComponent,
    AlertIncidentComponent,
    HelpComponent,
    CommunityForumComponent,
    TrainingComponent,
    NewgridComponent,
    RecentticketsComponent,

    // ReportComponentComponent,
    // PageComponentComponent,
    // PreviewComponent,
    // LayoutSidenavRightComponent,
    // ConfiguredSearchComponent,
    // FileComponent,
    // FiledirectiveDirective,
    // MyUploadsComponent,
    // AgentscriptPreviewComponent,
    // AdvancedSearchComponent,
    // QueryProcessorComponent,
    // DynamicFormsComponent,
    // ReportLinkComponent,
    // HomeComponent,
    LayoutComponent,
    QueryProcessorComponent,
    QueryProcessorVirtualRowComponent,
    ReportLinkComponent,
    DynamicFormsComponent,
    GlobalsearchcomponentComponent,
    NotificationsComponent,
    NewanswerComponent,
    AiknowledgebaseComponent
  ],
  providers: [
    // LayoutService,
    BsDatepickerConfig,
    Title,
    ApiserviceService
  ],
  exports: [
    TabsComponent,
    TabComponent,
    KnowledgebaseComponent,
  ],
  entryComponents: [
    TabComponent,
    PreviewComponent
  ]
})
export class LayoutModule { }
